export enum DefinedEventsRequestTypes {
  SetDefinedEventRequest = 'definedevent.set.request',
  SetDefinedEventSuccess = 'definedevent.set.success',
  SetDefinedEventFailure = 'definedevent.set.failure',
  GetAllDefinedEventsRequest = 'definedevent.getall.request',
  GetAllDefinedEventsSuccess = 'definedevent.getall.success',
  GetAllDefinedEventsFailure = 'definedevent.getall.failure',
  ArchiveDefinedEventRequest = 'definedevent.archive.request',
  ArchiveDefinedEventSuccess = 'definedevent.archive.success',
  ArchiveDefinedEventFailure = 'definedevent.archive.failure',
  DefinedEventAccessRequest = 'definedevent.access.request',
  DefinedEventAccessSuccess = 'definedevent.access.success',
  DefinedEventAccessFailure = 'definedevent.access.failure',
  ArchiveMultiDefinedEventsRequest = 'definedevent.archivemulti.request',
  ArchiveMultiDefinedEventsSuccess = 'definedevent.archivemulti.success',
  ArchiveMultiDefinedEventsFailure = 'definedevent.archivemulti.failure',
  SnoozeDefinedEventRequest = 'definedevent.snooze.request',
  SnoozeDefinedEventSuccess = 'definedevent.snooze.success',
  SnoozeDefinedEventFailure = 'definedevent.snooze.failure',
  UnSnoozeDefinedEventRequest = 'definedevent.unsnooze.request',
  UnSnoozeDefinedEventSuccess = 'definedevent.unsnooze.success',
  UnSnoozeDefinedEventFailure = 'definedevent.unsnooze.failure',
}
